import type { APIRequestQueryParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type OrganizationsSavvySearchParams =
  APIRequestQueryParams<'/api/v4/organization/list'>;

type OrganizationsSavvySearchResults =
  APIResponse<'/api/v4/organization/list'>[number];

export const fetchOrganizationsSavvySearchResults = async (
  params: OrganizationsSavvySearchParams,
) => {
  return await get<OrganizationsSavvySearchResults[]>('/v4/organization/list', {
    params,
  });
};
